module["exports"] = [
  "07# ### ####",
  "+389 7# ### ####"
];
